import alphaDecor from "./AlphaDecor";
import breastCancerPrediction from "./BreastCancerPrediction";
import housePricePrediction from "./HousePricePrediction";
import luxMobile from "./LuxMobile";
import movieRecommendationSystem from "./MovieRecommendationSystem";

const projects = [
  alphaDecor,
  luxMobile,
  movieRecommendationSystem,
  breastCancerPrediction,
  housePricePrediction,
];
export default projects;
